module.exports = __webpack_public_path__ + "img/menu_close.b0725cd1.svg";